exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2r5ubURmcmLhCaod-hBa3U{margin:auto;width:90%;height:200px;text-align:center;border:1px dashed;font-size:1em;color:#4498c0}._2usg-B3HDHNGBHMslZkUhW{vertical-align:center;color:grey;height:100px;margin-top:50px}._1XN-ROv-pxOx1FAlLk9NPp{border:none;background-color:#4498c0;color:#fff;margin:15px 5px 10px;height:30px;padding:5px 10px}._1XN-ROv-pxOx1FAlLk9NPp i{vertical-align:middle;font-size:20px;margin-right:5px}._1inlf-gLZR05n6SOBMcdRY{margin:auto;width:90%;height:auto;text-align:center;border:1px dashed;font-size:1em;color:#707274;padding:20px}", ""]);

// exports
exports.locals = {
	"dropZone": "_2r5ubURmcmLhCaod-hBa3U",
	"dropZoneText": "_2usg-B3HDHNGBHMslZkUhW",
	"dropZoneImportButton": "_1XN-ROv-pxOx1FAlLk9NPp",
	"fileError": "_1inlf-gLZR05n6SOBMcdRY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/aoi/DropZone.css
// module id = 1455
// module chunks = 1